import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <g>
        <path
          fill={colourFill}
          d="M6.4 71h50a6 6 0 0 1-1.13-3.54v-5.9H3v6A3.4 3.4 0 0 0 6.4 71ZM64 15.56a3.4 3.4 0 0 0-3.4-3.4H56v-1.51a5.23 5.23 0 0 0-4.46-5.26 5.09 5.09 0 0 0-5.7 5.07v1.7h-4.35v-1.51A5.23 5.23 0 0 0 37 5.39a5.09 5.09 0 0 0-5.71 5.07v1.7H27v-1.51a5.23 5.23 0 0 0-4.5-5.26 5.09 5.09 0 0 0-5.7 5.07v1.7h-6a3.4 3.4 0 0 0-3.4 3.4V26H64Zm-39.21-3.4h-3.64v6a2.28 2.28 0 0 1 1.09 2 2.18 2.18 0 1 1-4.35 0 2.28 2.28 0 0 1 1.09-2v-7.63a2.86 2.86 0 0 1 1.94-2.76 2.91 2.91 0 0 1 3.87 2.69Zm14.52 0h-3.63v6a2.3 2.3 0 0 1 1.09 2 2.18 2.18 0 1 1-4.36 0 2.3 2.3 0 0 1 1.09-2v-7.63a2.86 2.86 0 0 1 1.94-2.76 2.91 2.91 0 0 1 3.87 2.69Zm14.52 0H50.2v6a2.28 2.28 0 0 1 1.09 2 2.18 2.18 0 1 1-4.36 0 2.3 2.3 0 0 1 1.09-2v-7.63A2.87 2.87 0 0 1 50 7.77a2.9 2.9 0 0 1 3.86 2.69Z"
        />
        <path
          fill={colourFill}
          d="M57.46 61.22v6.69a3.41 3.41 0 0 0 2.62 3.38A3.31 3.31 0 0 0 64 68V28.14H7.36v32h49a1.14 1.14 0 0 1 .8.33 1.1 1.1 0 0 1 .33.81Zm-7.33-18.14A17.87 17.87 0 0 1 36 56.05a1.29 1.29 0 0 1-.48 0 17.87 17.87 0 0 1-14.09-13c-1-4-.19-7.61 2.06-9.5 4-3.29 8.63-1.71 12.27 1.91 3.64-3.62 8.28-5.2 12.27-1.91 2.25 1.89 3 5.52 2.06 9.5Z"
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
